/* import __COLOCATED_TEMPLATE__ from './asset-graphic.hbs'; */
import { computed } from '@ember/object';
import Component from '@ember/component';
import ICONS from '../constants/assets/icons';
import {
  EXTENSIONS_BY_CATEGORY,
  CATEGORIES_BY_EXTENSION
} from '../constants/assets';

/**
 * A component which renders a either a thumbnail or an icon for an asset.
 */
export default Component.extend({
  /**
   * @inheritDoc
   */
  classNames: ['SH-c-asset-graphic'],
  classNameBindings: [
    'isLarge:SH-c-asset-graphic--is-large',
    '_hasVideoThumbnail:SH-c-asset-graphic--has-video-thumbnail',
  ],

  /*********************************
   * REQUIRED PARAMS
   *********************************/

  /**
   * @type {Boolean} Whether this is the large version.
   */
  isLarge: null,

  /**
   * @type {String} The asset's extension.
   */
  extension: null,

  /**
   * @type {String} The asset's thumbnail URL.
   */
  thumbnail: null,

  /*********************************
   * PRIVATE
   *********************************/

  /**
   * @type {Boolean} Whether this asset is a video and it has a thumbnail.
   */
  _hasVideoThumbnail: computed('extension', 'thumbnail', function() {
    const extension = this.get('extension').toUpperCase();
    const isVideo = EXTENSIONS_BY_CATEGORY['VIDEO'].includes(extension);
    const hasThumbnail = !!this.get('thumbnail');

    return isVideo && hasThumbnail;
  }),

  /**
   * @type {String} The URL of the image to display.
   */
  _imageURL: computed('extension', 'thumbnail', 'isLarge', function() {
    const thumbnail = this.get('thumbnail');

    // Return a thumbnail if it exists.
    if (thumbnail) {
      return thumbnail;
    }

    // Fallback to a file category icon if no thumbnail exists.
    const extension = this.get('extension').toUpperCase();
    const iconSize = this.get('isLarge') ? 'LARGE' : 'SMALL';
    const category = CATEGORIES_BY_EXTENSION[extension] || 'DEFAULT';

    return ICONS.ASSETS[category][iconSize];
  }),
});
